import $ from 'jquery'

export default {
  name: 'index',
  data () {
    return {
      items: 4,
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 0,
        effect: 'fade',
        loop: true,
        autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    }
  },
  components: {

  },
  mounted () {

  },
  computed: {

  },
  methods: {
    toTop () {
      $('body,html').animate({scrollTop: 0}, 1000)
      return false
    },
    big (e) {
      $(e.target).closest('.nowDiv').removeClass('pulseBack').addClass('pulse')
    },
    nowDiv (e) {
      $(e.target).closest('.nowDiv').removeClass('pulse').addClass('pulseBack')
    }
  }
}

$(window).on('scroll', () => {
  if (window.scrollY > 300) {
    $('.caseImg').css({
      top: '260px'
    }).addClass('slideInUp')
    $('.toTop').show()
  } else {
    $('.caseImg').css({
      top: '1000px'
    }).removeClass('slideInUp')
    $('.toTop').hide()
  }

  if (window.scrollY > 900) {
    $('.caseWord').css({
      right: '0'
    }).addClass('fadeInRight')
  } else {
    $('.caseWord').css({
      right: '-50%'
    }).removeClass('fadeInRight')
  }

  if (window.scrollY > 1400) {
    $('.caseWord3').css({
      left: '0'
    }).addClass('fadeInLeft')
  } else {
    $('.caseWord3').css({
      left: '-50%'
    }).removeClass('fadeInLeft')
  }
})



// WEBPACK FOOTER //
// ./src/components/index/index.js